import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/',
)({
  loader: async ({ context: { queryClient }, params }) => {

    const { entity_type_id, entity_id } = params;
    const data = await queryClient.fetchQuery(getEntityQueryOptions(entity_type_id, entity_id));

    const detailsTab = data?.view?.tabs?.[0];

    throw redirect({
      replace: true,
      to: '/$module_id/$entity_type_id/$entity_id/details/$detailsTab',
      params: {
        module_id: params.module_id,
        entity_type_id: params.entity_type_id,
        entity_id: params.entity_id,
        detailsTab: detailsTab?.name?.toLowerCase().replace(/ /g, "-") as string,
      }
    })

  }
})

